import { render, staticRenderFns } from "./ReviewItemsManager.vue?vue&type=template&id=7ae456e6&scoped=true&"
import script from "./ReviewItemsManager.vue?vue&type=script&lang=js&"
export * from "./ReviewItemsManager.vue?vue&type=script&lang=js&"
import style0 from "./ReviewItemsManager.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReviewItemsManager.vue?vue&type=style&index=1&id=7ae456e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae456e6",
  null
  
)

component.options.__file = "ReviewItemsManager.vue"
export default component.exports